// src/components/BranchSelector.jsx
import React, {useEffect} from 'react';
import {generateViewId, STORAGE_KEY, useBranch} from '../context/BranchContext';
import styles from '../styles/module/BranchSelector.module.css';
import {linkLogoHami, linkLogoWhite} from "./layout/Header";


export default function BranchSelector() {
    const {setBranch} = useBranch();
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const viewidFromUrl = urlParams.get('viewid'); // có thể là null
        const currentIdView = localStorage.getItem(STORAGE_KEY);
        if ((currentIdView && viewidFromUrl == currentIdView) || (!currentIdView && viewidFromUrl)) {
            localStorage.setItem(STORAGE_KEY, "");
            handleOnClickHami()
        }
    }, []);
    const handleOnClickHami = () => {
        setBranch("HA_MI");
        let newViewId = generateViewId();
        localStorage.setItem(STORAGE_KEY, newViewId)

    }
    const handleOnClickKando = () => {
        setBranch('KANDO');
        localStorage.setItem(STORAGE_KEY, '')
    }

    return (
        <div className={styles.container}>
            {/* KANDO - Chi nhánh chính (không redirect) */}
            <div
                className={`${styles.split} ${styles.kando}`}

            >
                <div className={`${styles.content} ${styles.contentKando}`}>
                    <h1 className={styles.title}>Willkommen!</h1>
                    <div className={styles.logoWrapper} onClick={handleOnClickKando}>
                        <img src={linkLogoWhite} alt="KANDO Logo" className={styles.logo}/>
                        <div className={styles.clickText}>klicken Sie hier -></div>
                    </div>
                    <p className={styles.infoLine}>
                        <span className={styles.label}>ADRESSE:</span>
                        <div
                            className={styles.clickable}
                            onClick={() => window.open("https://maps.app.goo.gl/EwsJpzy3Zy9o8Fmb8", "_blank")}
                            title="Mở Google Maps"
                        >
                            • Am Bahnhof 3, 09599 Freiberg im Alekto Hotel •
                        </div>
                    </p>

                    <p className={styles.infoLine}>
                        <span className={styles.label}>TELEFON:</span>
                        <a
                            href="tel:+493731794455"
                            className={styles.clickable}
                            title="Gọi ngay"
                        >
                            03731 794455
                        </a>
                    </p>
                    <p className={styles.infoLine}>
                        Kando Restaurant : Authentische Aromen aus Thailand, Vietnam und Japan – neu interpretiert.
                    </p>


                </div>
            </div>

            {/* HAMI - Chi nhánh phụ (sẽ redirect) */}
            <div
                className={`${styles.split} ${styles.hami}`}

            >
                <div className={`${styles.content} ${styles.contentHami}`}>
                    <h1 className={styles.title}>Willkommen!</h1>
                    <div className={styles.logoWrapper} onClick={handleOnClickHami}>
                        <img src={linkLogoHami} alt="HAMI Logo" className={styles.logo}/>
                        <div className={styles.clickText}>klicken Sie hier -></div>
                    </div>
                    <p className={styles.infoLine}>
                        <span className={styles.label}>ADRESSE:</span>
                        <div
                            className={styles.clickable}
                            onClick={() => window.open("https://maps.app.goo.gl/dczj2LdVkYREyRVk8", "_blank")}
                            title="Mở Google Maps"
                        >
                            • Mönchstraße 01, 09599 Freiberg •
                        </div>
                    </p>

                    <p className={styles.infoLine}>
                        <span className={styles.label}>TELEFON:</span>
                        <a
                            href="tel:+4937312188290"
                            className={styles.clickable}
                            title="Gọi ngay"
                        >
                            4937312188290
                        </a>
                    </p>
                    <p className={styles.infoLine}>
                        Ha Mi Restaurant : Frisches Sushi & kreative europäisch-asiatische Tellergerichte
                    </p>

                </div>
            </div>
        </div>
    );
}